<ng-container *ngIf="!isInTable()">
    <mat-divider *ngIf="props['label2Title']"></mat-divider>
    <label [id]="key+'label'" style="width: 100%; gap:10px; margin-bottom: 20px;" class="d-flex flex-column">
        <div [class.mat-title]="props['label2Title']" [class.label-title]="props['label2Title']">{{props['label2']}}<span *ngIf="props.required" class="required-field-mark"> *</span></div>
        <ng-container #fieldComponent></ng-container>
    </label>
</ng-container>

<ng-container *ngIf="isInTable()">
    <label [id]="key+'label'" style="width: 100%; gap:10px;" class="d-flex flex-column">
        <ng-container #fieldComponent></ng-container>
    </label>
</ng-container>
